// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5610) return "static/chunks/5610-build-1755555403949-86996bde807fcb70.js";
	if (chunkId === 2626) return "static/chunks/2626-build-1755555403949-3c0675092693b37b.js";
	if (chunkId === 8030) return "static/chunks/8030-build-1755555403949-ff52f6a06c82a940.js";
	if (chunkId === 5571) return "static/chunks/5571-build-1755555403949-d0ba0078f48871e9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-build-1755555403949." + {"354":"b66b559e40c59064","3296":"8fcbcf6c97564f2e","6483":"a7d7ca454d38bf77","8096":"e47a436da9213d0b","8241":"802bf5da022a47fa","8505":"14bc1073e9cd6c88","8847":"e494c6549ee411f0","9443":"ac6a1b371332c107"}[chunkId] + ".js";
};